import {Loader} from "@mantine/core";

export default function LoadingScreen() {
return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh', // full height of the viewport
        width: '100vw'   // full width of the viewport (optional)
      }}>
        <Loader/>
      </div>
  );
}
